module.exports = __webpack_public_path__ + "static/media/shdocvw_260.35da352e.ico";